module.exports = __webpack_public_path__ + "img/2025-0327-01-02.f2e5df4c.png";